<template>
  <div class="nav-tab">
    <div class="logo">
      <img src="https://inmotion-app.oss-cn-shenzhen.aliyuncs.com/tewamoto/logo-2%40.png" alt="" />
    </div>
    <div class="right-box" v-if="$isPC">
      <div v-for="tab in tabList" :key="tab.name" class="tab-item" :class="{ active: isActive(tab) }">
        <router-link :to="tab.path">{{ tab.name }}</router-link>
      </div>
    </div>
    <div class="right-box" v-else>
      <span class="el-icon-s-unfold" @click="openMobile"></span>
    </div>
    <div v-if="isShow" class="mobile_popup">
      <div class="title">
        <img src="https://inmotion-app.oss-cn-shenzhen.aliyuncs.com/tewamoto/logo-2%40.png" alt="">
        <span class="el-icon-close" @click="closeHandle"></span>
      </div>
      <div class="tab-box">
        <div v-for="tab in tabList" :key="tab.name" class="tab-item" :class="{ active: isActive(tab) }"
          @click="goTo(tab.path)">
          <router-link :to="tab.path">{{ tab.name }}</router-link>
          <span class="el-icon-arrow-right"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'navTab',
    data () {
      return {
        tabList: [
          { name: 'HOME', path: '/home' },
          { name: 'M3 SERIES', path: '/M3SERIES' },
          { name: 'UPCOMING PRODUCTS', path: '/newProduct' },
          { name: 'ABOUT', path: '/about' },
          { name: 'DEALER NETWORK', path: '/contact' },
        ],
        isShow: false
      }
    },
    mounted () {

    },
    methods: {
      isActive (tab) {
        return this.$route.path === tab.path;
      },
      openMobile () {
        this.isShow = true
      },
      closeHandle () {
        this.isShow = false
      },
      goTo (path) {
        // 禁止同页面路由跳转
        if (this.$route.path === path) {
          this.isShow = false
          return;
        }
        this.$router.push(path)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Tilt+Warp&display=swap');
  @media (min-width: 769px) {
    .nav-tab {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /* PC 宽屏：内容限制在 1440px 内居中，带鱼屏 / 4K 不把 logo 与菜单拉到两端 */
      padding: 29px max(56px, calc((100% - 1440px) / 2));
      box-sizing: border-box;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 999;

      .logo {
        /* 宽屏放大到 340px；窄 PC（约 1025~1200）自动收窄，避免与菜单挤压（min 非断点） */
        width: min(340px, 24vw);
        height: 42px;   // 原 34px，同步放大；object-fit:contain 保证比例不变形
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain; // logo 按比例完整显示，不被拉伸变形
        }
      }

      .right-box {
        display: flex;
        justify-content: flex-end;
        column-gap: 25px;

        .tab-item {
          a {
            font-family: "AlibabaPuHuiTi";
            font-weight: 900;
            color: #fff;
            text-decoration: none;
            /* 宽屏 21px（原 16px 偏小，按反馈放大）；窄 PC 自动收窄，保证 5 个菜单不换行 */
            font-size: min(21px, 1.6vw);
          }
        }

        .active {
          a {
            color: #FFA400;
          }
        }
      }

    }
  }


  /* 平板档 769~1024：横向菜单压缩，避免 5 个菜单在窄屏拥挤 */
  @media (min-width: 769px) and (max-width: 1024px) {
    .nav-tab {
      padding: 18px 24px;

      .logo {
        width: 220px;
        height: 28px;
      }

      .right-box {
        column-gap: 16px;

        .tab-item a {
          font-size: 14px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .nav-tab {
      width: 100%;
      box-sizing: border-box;
      padding: 11px 11px 10px 11px;
      font-size: 4.8px;
      column-gap: 5.2px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 998;
      background: linear-gradient(to bottom, rgba(0, 0, 0, .4), rgba(255, 255, 255, .1));

      .logo {
        width: 110px;
        /* height: 12px; */

        img {
          width: 100%;
          text-align: center;
        }
      }

      .right-box {
        font-size: 20px;
        color: #fff;
      }

      .mobile_popup {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 1);


        .title {
          display: flex;
          justify-content: space-between;
          padding: 24px;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(255, 255, 255, .6);

          img {
            width: 150px;
            height: auto;
          }

          span {
            color: #FFA400;
            font-size: 20px;
          }
        }

        .tab-box {
          padding: 24px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          row-gap: 20px;

          .tab-item {
            font-size: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: "AlibabaPuHuiTi";
            font-weight: 800;

            a {
              color: #fff;
              text-decoration: none;
            }

            span {
              color: #fff;
            }
          }

          .active {
            a {
              color: #FFA400 !important;
            }

            span {
              color: #FFA400 !important;
            }
          }
        }
      }
    }
  }
</style>